<template>
  <div class="content">
    <div
      class="all-set-container d-flex flex-column justify-center align-center"
    >
      <p class="h6 blue-grey--text text--darken-3">
        {{ $t('common.users.add_bulk_success') }}
      </p>
      <p class="body-2 blue-grey--text text--darken-1 ma-0 pa-0">
        {{ createdUsersCount }}
      </p>
      <div class="d-flex" v-if="missed !== 0">
        <p class="body-2 blue-grey--text text--darken-1 ma-0 pa-0">
          {{ missedUsers }}
        </p>
        <p
          class="body-2 blue--text ma-0 pa-0 ml-2 cursor-pointer"
          @click="$emit('viewAccounts')"
        >
          {{ $t('common.users.add_bulk_view_accounts') }}
        </p>
      </div>
      <div class="mt-4">
        <Button
          plain
          outlined
          color="primary"
          data-testid="addUsersBulk-button-summaryFinish"
          :text="$t('common.button.finish')"
          @click="handleFinish"
        />
        <Button
          class="ml-4"
          color="primary"
          data-testid="addUsersBulk-button-summaryAddMore"
          :text="$t('common.button.add_more')"
          @click="$emit('addMore')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'SummaryView',

  mixins: [mixin],

  components: {
    Button,
  },

  props: {
    created: {
      type: Number,
      default: 0,
    },
    missed: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      prevRoute: null,
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  methods: {
    handleFinish() {
      if (this.prevRoute?.name) {
        this.$router.back()
      } else {
        this.navigateTo({ name: 'people' })
      }
    },
  },

  computed: {
    createdUsersCount() {
      return this.$t('common.users.add_bulk_success_descriptionWithCount', {
        count: this.created,
      })
    },

    missedUsers() {
      return this.$t('common.users.add_bulk_description_missedWithCount', {
        count: this.missed,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 65vh;
}

.all-set-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 2px dashed $color-blue-grey-lighten1;
  overflow: hidden;
  transition: all 0.2s;
}
</style>
